<template>
    <div >
      <Card>
    <Row >
        <Col span="10">
          <Select v-model="bankAccountId"
          placeholder="Pilih Bank"

              clearable >
              <Option
                  v-for="bankAccount in bankAccounts"
                  :value="bankAccount.id"
                  :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
          </Select>
        </Col>

        <Col span="12" offset="2">
          <Date-picker
              v-show="bankAccountId"
              v-model="transactionDate"
              type="date"
              placeholder="Tanggal Transaksi"
              format="dd/MM/yyyy">
          </Date-picker>
        </Col>
    </Row>
    <br/>
    <Row>
        <Col span="24">
          <div v-show="transactionDate && bankAccountId">
              <Upload
                  ref="upload"
                  :action="this.serverUrlUploadXls"
                  :headers="this.requestHeader"
                  :format="['xls','xlsx']"
                  name="xls_file"
                  :data="this.dataUpload"
                  :on-format-error="handleFormatError"
                  :on-error="onErrorUpload"
                  :on-success="onSuccessUpload">
                  <Button type="success" icon="ios-cloud-upload-outline">Choose Xls</Button>
              </Upload>
              <i>Notes: Pastikan ada kolom "amount" pada Excel dan format cell = Text</i>

          </div>
        </Col>
    </Row>
      </Card>
    </div>
</template>

<script>
import { HTTP } from "@/components/http-lib";
import moment from 'moment'

let serverUrl = localStorage.getItem("serverUrl");
let token = localStorage.getItem("access_token");
let requestHeader = {
  Authorization: "Bearer " + token
};

export default {
  props: {
    customer: Object,
    calls: Array
  },
  data: () => ({
    serverUrl: "",
    serverUrlUploadXls: "",
    requestHeader: "",
    bankAccountId: "",
    transactionDate: "",
    bankAccounts: [],
    dataUpload: {
      bankAccountId: "",
      transactionDate: ""
    }
  }),
  methods: {
    handleFormatError: function(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select XLS os XLSX"
      });
    },
    onSuccessUpload: function(response, file) {
      console.log('onSuccessUpload...')
      this.bankAccountId = ''
      this.$refs.upload.clearFiles()
      this.$emit("on-success-upload", response);
    },
    onErrorUpload: function(response, file) {
      console.log('onErrorUpload...')
      this.$emit("on-error-upload", response.message);
    },

    getBankAccount: function() {
      // this.loadingSearch  = true;
      HTTP.get("bankAccount/findAll/active")
        .then(response => {
          this.bankAccounts = response.data;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
    }
  },

  watch: {
    bankAccountId: function(val, oldVal) {
      this.dataUpload.bankAccountId = val;
    },
    transactionDate: function(val, oldVal) {
      this.dataUpload.transactionDate = moment(val).format('YYYY/MM/DD')
    }
  },

  created() {
    let token = localStorage.getItem("access_token");
    let requestHeader = {
      Authorization: "Bearer " + token
    };
    this.requestHeader = requestHeader;

    let serverUrl = localStorage.getItem("serverUrl");
    this.serverUrlUploadXls = serverUrl + "paymentPending/importFromXls";

    this.getBankAccount();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// UploadXls.vue?02cbb159